import React from "react";
import { Spinner } from "react-bootstrap";

/**
 * Full-area fallback for React.lazy() route / view chunks.
 * @param {{ fullViewport?: boolean }} props — use fullViewport for full-screen admin load
 */
export default function ViewLoader({ fullViewport = false }) {
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center w-100 py-5"
      style={{ minHeight: fullViewport ? "100vh" : "min(70vh, 32rem)" }}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <Spinner animation="border" variant="primary" />
      <span className="visually-hidden">Φόρτωση</span>
      <p className="text-muted small mt-3 mb-0">Φόρτωση…</p>
    </div>
  );
}
